import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Skeleton as SkeletonComponent } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

export function Skeleton() {
  return (
    <ErrorHandler location="src/pages/private/Dashboards/SourceReportsDashboard/components/Skeleton/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col span={{ xs: 2 }}>
            <SkeletonComponent height={50} />
          </Grid.Col>
          <Grid.Col span={{ xs: 3 }}>
            <SkeletonComponent height={50} />
          </Grid.Col>
          <Grid.Col span={{ xs: 1 }}>
            <SkeletonComponent height={50} />
          </Grid.Col>
          <Grid.Col css={{ marginTop: '24px' }} span={{ xs: 12 }}>
            <SkeletonComponent height={400} />
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
